const locale = {
	// #region User Dashboard
	WELCOME: 'Bentornato,',
	PROFILE_LINK: 'Vai al tuo profilo ',

	TAB_HOME: 'Home',
	TAB_STATS: 'Statistiche',
	TAB_LEADS_MAP: 'Mappa Lead',
	TAB_DAILYWORKREPORTS: 'Rapportini giornalieri',
	TAB_ORDERS_BILLING: 'Fatturazione Ordini',
	TAB_ACTIVITIES_OVERVIEW: 'Situazione Attività',
	TAB_OPPORTUNITIES_OVERVIEW: 'Situazione Opportunità',
	TAB_ORDERS_OVERVIEW: 'Situazione Ordini',
	TAB_OPPORTUNITIES_STATS: 'Statistiche Opportunità',
	TAB_ORDERS_STATS: 'Statistiche Ordini',

	FAST_ACTIONS_WIDGET_TITLE: 'Azioni rapide',
	LINKS_WIDGET_TITLE: 'Collegamenti',

	TOT_VALUE: 'Valore totale: {value}',

	WIDGET_YESTERDAY: 'Ieri',
	WIDGET_TODAY: 'Oggi',
	WIDGET_TOMORROW: 'Domani',
	WIDGET_NEXT_7_DAYS: 'Prossimi 7 giorni',
	WIDGET_NEXT_30_DAYS: 'Prossimi 30 giorni',

	WIDGET_LAST_WEEK: 'Scorsa settimana',
	WIDGET_THIS_WEEK: 'Questa settimana',
	WIDGET_LAST_MONTH: 'Scorso mese',
	WIDGET_THIS_MONTH: 'Questo mese',
	WIDGET_THIS_YEAR: 'Questo anno',
	WIDGET_LAST_YEAR: 'Scorso anno',
	WIDGET_ALL: 'Tutte',
	// #endregion

	// #region Dashboard Stats table
	DASHBOARD_STATS_TABLE_NO_VALUE: 'Non definito',
	// #endregion

	// #region Dashboard Opportunities stats tab
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_DATE_TO_MONTHYEAR: 'Mese fine',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_RATING: 'Temperatura',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_USER_ASSIGNED: 'Utente assegnato interno',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_COMPANY: 'Azienda',

	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_OPEN: 'N. totale',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_QUOTATIONS: 'N. proposte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_SIGNED: 'N. vinte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_VALUE_QUOTATIONS: 'Valore proposte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_VALUE_DEFINITIVE: 'Valore vinte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_AVG_TIME_QUOTE_TO_ORDER: 'Tempo attraversamento medio',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_AVG_SUCCESS_RATE: 'Percentuale conversione',

	DASHBOARD_OPPORTUNITIES_STATS_FOOTER_TOT_VALUE_QUOTATIONS: 'Totale valore proposte: {value}',
	DASHBOARD_OPPORTUNITIES_STATS_FOOTER_TOT_VALUE_DEFINITIVE: 'Totale valore vinte: {value}',
	// #endregion

	// #region Dashboard Orders stats tab
	DASHBOARD_ORDERS_STATS_COLUMN_DATE_SIGN_MONTHYEAR: 'Mese firma',
	DASHBOARD_ORDERS_STATS_COLUMN_USER_ASSIGNED: 'Utente assegnato interno',
	DASHBOARD_ORDERS_STATS_COLUMN_COMPANY: 'Azienda',

	DASHBOARD_ORDERS_STATS_COLUMN_TOT_OPEN: 'N. totale',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_QUOTATIONS: 'N. proposti',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_SIGNED: 'N. firmati',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_VALUE_QUOTATIONS: 'Valore proposti',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_VALUE_DEFINITIVE: 'Valore firmati',
	DASHBOARD_ORDERS_STATS_COLUMN_AVG_TIME_QUOTE_TO_ORDER: 'Tempo attraversamento medio',
	DASHBOARD_ORDERS_STATS_COLUMN_AVG_SUCCESS_RATE: 'Percentuale conversione',

	DASHBOARD_ORDERS_STATS_FOOTER_TOT_VALUE_QUOTATIONS: 'Totale valore proposti: {value}',
	DASHBOARD_ORDERS_STATS_FOOTER_TOT_VALUE_DEFINITIVE: 'Totale valore vinti: {value}'
	// #endregion
};

export default locale;
